(function() {
  'use strict';
  if (window.eoGridPickerBound) return;
  window.eoGridPickerBound = true;

  function guard(event, form) {
    const picker = form.querySelector('[data-eo-grid-picker]');
    if (!picker) return;
    const choices = Array.from(picker.querySelectorAll('[data-eo-grid-choice]'));
    const invalid = choices.find(choice => !choice.value || !choice.checkValidity());
    if (choices.length && !invalid && !picker.querySelector('[data-eo-grid-unavailable]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const error = picker.querySelector('[data-eo-grid-error]');
    if (error) error.hidden = false;
    if (invalid) invalid.focus();
  }

  // The wishlist is rendered in the browser from product JSON, which carries no
  // metafields. Ask the product's grid-flag view before letting a quick add run;
  // configured panels, and any lookup failure, go to the full product page.
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const lookups = new Map();
  function productPath(handle) {
    return root + 'products/' + encodeURIComponent(handle);
  }
  function lookup(handle) {
    if (!lookups.has(handle)) {
      // No JSON Accept header: Shopify answers that with the product's own JSON
      // and ignores ?view=, so the alternate template would never render.
      lookups.set(handle, fetch(productPath(handle) + '?view=grid-flag', {
        credentials: 'same-origin'
      }).then(response => {
        if (!response.ok) throw new Error('grid-flag ' + response.status);
        return response.json();
      }).then(result => {
        if (typeof result.required !== 'boolean') throw new Error('grid-flag shape');
        return result;
      }).catch(error => {
        lookups.delete(handle);
        throw error;
      }));
    }
    return lookups.get(handle);
  }

  function guardListAdd(event, button) {
    // A checked re-dispatch passes through to the theme handler (or native submit).
    if (button.dataset.eoGridChecked === '1') return;
    const row = button.closest('[data-wishlist-added], .item-product');
    const handleEl = row && row.querySelector('[data-product-handle]');
    const handle = handleEl && handleEl.getAttribute('data-product-handle');
    if (!handle) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    lookup(handle).then(result => {
      button.removeAttribute('aria-busy');
      if (result.required) {
        window.location.assign(result.url || productPath(handle));
        return;
      }
      button.dataset.eoGridChecked = '1';
      try {
        button.click();
      } finally {
        delete button.dataset.eoGridChecked;
      }
    }).catch(() => {
      button.removeAttribute('aria-busy');
      window.location.assign(productPath(handle));
    });
  }

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const listButton = event.target.closest('[data-wishlist-container] button.btnAddToCart');
    if (listButton) {
      guardListAdd(event, listButton);
      return;
    }
    const button = event.target.closest('button[name="add"], .product-form__cart-submit');
    const form = button && (button.form || button.closest('form'));
    if (form) guard(event, form);
  }, true);

  document.addEventListener('submit', event => {
    if (!(event.target instanceof HTMLFormElement)) return;
    if (event.target.closest('[data-wishlist-container]')) {
      const button = event.target.querySelector('button.btnAddToCart');
      if (button && button.dataset.eoGridChecked !== '1') {
        event.preventDefault();
        event.stopImmediatePropagation();
        button.click();
      }
      return;
    }
    guard(event, event.target);
  }, true);

  document.addEventListener('change', event => {
    if (!(event.target instanceof Element)) return;
    if (!event.target.matches('[data-eo-grid-choice]')) return;
    const picker = event.target.closest('[data-eo-grid-picker]');
    const error = picker && picker.querySelector('[data-eo-grid-error]');
    if (error) error.hidden = true;
  });
})();
